import React from "react";

class Speaker1 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
    };
  }

  componentDidMount() {
    document.title =
      "Keynote Speakers - 20th International Conference on Information Technology and Applications (ICITA)";
  }

  render() {
    const { data } = this.state;
    return (
      <div>
        <div className="intro">
          <div className="container">
            <div className="row">
              <div className="col text-center">
                <div className="section_title_container text-center">
                  <div className="section_title">
                    <h1>Keynote Speaker</h1>
                  </div>
                </div>
                <div className="intro_text text-center">
                  <div className="row speakers_row">
                    <div className="col-xl-12 col-md-12">
                      <img
                        src={require("../assets/img-comm/yan.jpg")}
                        alt=""
                        width="260"
                        height="240"
                      />
                      <h4>Dr Hong Yan </h4>

                      <div className="organiser_intro mt-2 col-md-12">
                        <div className="col-md-12">
                          <p align="center">
                            <i>
                              Department of Electrical Engineering City
                              University of Hong Kong
                            </i>
                          </p>
                        </div>
                      </div>
                      <br></br>
                      <div className="intro_left_content text_left">
                        <p align="left"></p>
                        <p align="left">
                          Hong Yan received his PhD degree from Yale University.
                          He was Professor of Imaging Science at the University
                          of Sydney and currently is Wong Chun Hong Professor of
                          Data Engineering and Chair Professor of Computer
                          Engineering at City University of Hong Kong. Professor
                          Yan's research interests include AI, bioinformatics,
                          pattern recognition, and signal and image processing.
                          He has over 600 journal and conference publications in
                          these areas. Professor Yan is an IEEE Fellow, IAPR
                          Fellow, Foreign Member of the European Academy of
                          Sciences and Arts, and Fellow of the US National
                          Academy of Inventors. He received the 2016 Norbert
                          Wiener Award from the IEEE SMC Society for
                          contributions to image and biomolecular pattern
                          recognition techniques.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Speaker1;
